// @flow strict

import { type PropsWithChildren } from '@mondough/public-web-components'
import * as React from 'react'
import { SectionThemes, SectionWrapper } from '../SectionWrapper'
import styles from './USAFeatureChecklist.module.scss'

const USAFeatureChecklist = ({
  title,
  features,
}: PropsWithChildren<{ features: string[], title: string }>) => (
  <SectionWrapper theme={SectionThemes.LIGHT} className={styles.section}>
    <h2 className={styles.title}>{title}</h2>
    <div>
      <ul className={styles.list}>
        {features.map(feature => {
          return <li key={feature}>{feature}</li>
        })}
      </ul>
    </div>
  </SectionWrapper>
)

export default USAFeatureChecklist
